// extracted by mini-css-extract-plugin
export default {"stepsSection":"StepsSection__stepsSection-yNS5","title":"StepsSection__title-NsbC"};